import { useEffect, useState } from 'react';

/**
 * Отложенное значение. Ввод в поиске меняется на каждую букву, а запрос должен уходить,
 * когда человек остановился — иначе на каждое нажатие идёт обращение к серверу.
 */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [delayed, setDelayed] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDelayed(value), delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);

  return delayed;
}
